/**
 * Display names for every Kalshi soccer league root the relay classifies as Soccer (relay/src/services/sports.ts),
 * taken from Kalshi's own series titles on 2026-10-26 (" Game" dropped). The fallback behind SOCCER_LEAGUE_LABELS
 * (Stuart, 2026-10-26: a Ligue 1 or Super Lig leg read only "Soccer"). Generated — keep it a plain table.
 */
export const SOCCER_LEAGUE_NAMES: Readonly<Record<string, string>> = {
  AFCAC: 'AFC Asia Cup',
  AFCCL: 'AFC Champions League',
  AFCON: 'AFCON',
  ALEAGUE: 'Australian A League',
  ALLSVENSKAN: 'Allsvenskan',
  APFDDH: 'APF Division de Honor',
  ARGNACB: 'Argentine Nacional B',
  ARGPREMDIV: 'Argentina Primera Division',
  ASEAN: 'ASEAN',
  AUTBUNDES: 'Austrian Bundesliga',
  BALLERLEAGUE: 'Baller League',
  BELGIANPL: 'Belgian Pro League',
  BOLPDIV: 'Bolivia Premier Division',
  BRASILEIRO: 'Brasileiro Serie A',
  CANPL: 'Canadian Premier League',
  CHLLDP: 'Chile Liga de Primera',
  CHNL1: 'China League 1',
  CHNSL: 'Chinese Super League',
  CLUBF: 'Club Friendly',
  CLUBWC: 'Club World Cup',
  CONCACAFCCUP: 'CONCACAF Champions Cup',
  CONMEBOLLIB: 'CONMEBOL Libertadores',
  CONMEBOLSUD: 'CONMEBOL Sudamericana',
  COPADELREY: 'Copa Del Rey',
  COPADOBRASIL: 'Copa do Brasil',
  COPPAITALIA: 'Coppa Italia',
  COUPEDEFRANCE: 'Coupe de France',
  CZEFL: 'Czech First League',
  CZEFNL: 'Czech National Football League',
  DANISHSUPERLIGA: 'Danish Superliga',
  DENSUPERLIGA: 'Danish Superliga',
  DFBPOKAL: 'DFB Pokal',
  ECULP: 'Ecuador Liga Pro',
  EERSTEDIV: 'Eerste Divisie',
  EFLCHAMPIONSHIP: 'EFL Championship',
  EFLCUP: 'EFL Cup',
  EFLL1: 'EFL League One',
  EGYPL: 'Egyptian Premier League',
  EKSTRAKLASA: 'Polish Ekstraklasa',
  ELITESERIEN: 'Eliteserien',
  ENGCS: 'England Community Shield',
  ENGNL: 'English National League',
  EREDIVISIE: 'Eredivisie',
  ESPSUPERCUP: 'Spain Super Cup',
  ETTAN: 'Ettan',
  EWSL: "England Women's Super League",
  FACUP: 'FA Cup',
  FIFAW: "FIFA Women's",
  FINALISSIMA: 'Finalissima',
  FINCUP: 'Suomen Cup',
  FINYL: 'Finnish Ykkosliiga',
  FRAPLW: "French Women's Première Ligue",
  FRASUPERCUP: 'France Super Cup',
  FROCUP: 'Faroe Islands Cup',
  FROPL: 'Faroe Islands Premier League',
  GER3L: 'German 3. Liga',
  GERSC: 'Germany Super Cup',
  GRECUP: 'Greek Cup',
  HNL: 'Croatia HNL',
  HUNNB1: 'Hungarian NB I',
  IDNSL: 'Indonesia Super League',
  INDSL: 'Indian Super League',
  INTERCONCUP: 'Intercontinental Cup',
  ISRNL: 'Liga Leumit',
  ISRPL: 'Israeli Premier League',
  ISRSCUP: 'Israel State Cup',
  ISRSUPCUP: 'Israel Super Cup',
  ITASUPERCUP: 'Italy Super Cup',
  J2LEAGUE: 'Japan J2 League',
  JLEAGUE: 'Japan J League',
  K2LEAGUE: 'Korea K-League 2',
  KLEAGUE: 'Korea K League',
  KNVBCUP: 'KNVB Cup',
  LEAGUESCUP: 'Leagues Cup',
  LIGAF: 'Spanish Liga F',
  LIGAPORTUGAL: 'Liga Portugal',
  LIGUE1: 'Ligue 1',
  LIGUE2: 'Ligue 2',
  LVAVIR: 'Latvian Virsliga',
  MYSL: 'Malaysia Super League',
  NCAAMSOCCER: 'College Soccer',
  NWSL: 'NWSL',
  PERLIGA1: 'Peru Liga 1',
  PRYLIGA1: 'Paraguay Primera',
  QSTARS: 'Qatar Stars League',
  ROML1: 'Romanian Liga I',
  SAPSL: 'South African Premiership',
  SAUDIPL: 'Saudi Pro League',
  SCOCUP: 'Scottish Cup',
  SCOTTISHPREM: 'Scottish Premiership',
  SERIEB: 'Serie B',
  SERIEC: 'Serie C',
  SGPPL: 'Singapore Premier League',
  SLGREECE: 'Super League Greece',
  SRBCUP: 'Serbian Cup',
  SRBSL: 'Serbian SuperLiga',
  SUPERLIG: 'Turkish Super Lig',
  SVK2L: 'Slovakian 2. Liga',
  SVKCUP: 'Slovakian Cup',
  SVNCUP: 'Slovenian Cup',
  SVNPL: 'Slovenian Prva Liga',
  SWISSLEAGUE: 'Swiss Super League',
  TACAPORT: 'Taca de Portugal',
  TFF1LIG: 'TFF 1. Lig',
  THAIL1: 'Thai League 1',
  TWEEDEDIV: 'Tweede Divisie',
  UAEPL: 'UAE Pro League',
  UEFASC: 'UEFA Super Cup',
  URYPD: 'Uruguay Primera Division',
  USL: 'USL Championship',
  USOPENCUP: 'US Open Cup',
  VENFUTVE: 'Venezuela Liga FUTVE',
  VLEAGUE1: 'Vietnam V-League 1',
};
